export default "__VITE_ASSET__CCzlFnQ9__"